<template>
  <div class="site__body">
    <div
      class="block-header block-header--has-breadcrumb block-header--has-title"
    >
      <div class="container">
        <div class="block-header__body">
          <div class="flexbox-page-info-container">
            <div class="flex-item-page-info-breadcrumbs">
              <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb-bottom-adjust"
                aria-label="breadcrumb">
                <ol class="breadcrumb__list">
                  <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                  <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                    <router-link to="/" class="breadcrumb__item-link"
                      >Home</router-link>
                  </li>
                  <li class="breadcrumb__item breadcrumb__item--parent">
                    <router-link to="/category" class="breadcrumb__item-link"
                      >Categories</router-link>
                  </li>
                  <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last"
                    aria-current="page">
                    <span class="breadcrumb__item-link">{{ breadcrumbs }}</span>
                  </li>
                  <li class="breadcrumb__title-safe-area" role="presentation"></li>
                </ol>
              </nav>
            </div>
            <div class="flex-item-page-info-title">
              <h1 class="block-header__breadcrumb-slim">{{ page_title }}</h1>
            </div>
          </div>
          <div class="flex-item-page-info-selected-vehcile" v-if="isKit">
            <selected-vehicle @openSelectVehicle="openDialog=true"></selected-vehicle>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="block-split block-split--has-sidebar"> -->
    <div class="block-split block-split--has-sidebar">
      <div class="container">
        <div class="block-split__row row no-gutters">

          <faceted-panel 
            ref="search_filter"
            :facet_filters="facet_filters"
            @filter_changed="filter_changed">
          </faceted-panel>

          <div class="block-split__item block-split__item-content col-auto" >
            <div class="block">
              <div class="products-view">
              <base-message
                v-if="servermessages.length > 0"
                :servermessages="servermessages"
              ></base-message>
              
                <page-display-options-search
                  ref="display_options"
                  @changePerPage="changePerPage"
                  :searchTerm="keyword"
                  :total_results="total_results"
                  @filterPrice="filterPrice"
                  @filterAvailability="filterAvailability"
                  @removeFilter="removeFilter"
                  @clearAll="clearAll"
                ></page-display-options-search>

                <result-list
                  ref="keywords_list"
                  @total_items="total_items"
                  :perPage="perPage"
                  :currentPage="page"
                  :filter_price="filter_price"
                  :filter_availability="filter_availability"
                  :keyword="keyword"
                  :level="level"
                  @total_showing="total_showing"
                  @show_messages="show_messages"
                  @isKit="kit_catalog"
                  @facet_keys="facet_keys"
                ></result-list>

                <div class="products-view__pagination">
                  <nav class="Page navigation example">
                    <base-pagination
                      :perPage="perPage"
                      :pages="pages"
                      :currentPage="page"
                      @updatePage="updatePage"
                    ></base-pagination>
                  </nav>
                  <div class="products-view__pagination-legend">
                    Showing {{ showing_page }} of {{ total_results }} products
                  </div>
                </div>
                <!-- <pagination></pagination> -->
              </div>
            </div>
          </div>

        </div>
        <div class="block-space block-space--layout--before-footer"></div>
      </div>
    </div>

    <base-select-vehicle @close="closeSelectVehicle" :open="openDialog === true" @selectedVehicleComplete="selectedVehicleComplete"></base-select-vehicle>
  </div>
</template>

<script>
import FacetedPanel from "./FacetedPanel";
import PageDisplayOptionsSearch from "./PageDisplayOptionsSearch";
import ResultList from "./ResultList";
// import Pagination from "../productbrowse/Pagination";
import BasePagination from "../../base/BasePagination.vue";
import { mapGetters } from 'vuex';
import MXVehicleSearch from '../../../mixins/vehicle_search.js';
import SelectedVehicle from "../searchresults/SelectedVehicle.vue";
import SolrHelper from '../../../mixins/solr_helper';

export default {
  name: "CategorySearch",
  components: {
    FacetedPanel,
    PageDisplayOptionsSearch,
    ResultList,
    BasePagination,
    SelectedVehicle,
  },
  props: {
    level: {
      type: Number,
      required: true
    },
    categoryUri1: {
      type: String,
      required: true,
    },
  },
  mixins: [MXVehicleSearch, SolrHelper],
  data() {
    return {
      page: 1,
      perPage: 10,
      pages: [],
      total_results: 0,
      showing: 0,
      servermessages: [],
      page_title: 'Search Results',

      isKit: false,
      openDialog: false,

      filter_availability: '',
      filter_price: '',

      facet_filters: {},
      selected_filter: {},
      last_filter: null,
    };
  },
  methods: {
    total_items(total) {
      this.total_results = total;
      this.pages = [];
      let numberOfPages = Math.ceil(this.total_results / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    total_showing(total) {
      this.showing = total;
    },
    updatePage(currentPage) {
      this.page = currentPage;
      this.$refs.keywords_list.solr_search(this.selected_filter, this.page);
    },
    changePerPage(newPerPage) {
      this.page = 1;
      this.perPage = newPerPage;
      this.total_items(this.total_results);
    },
    show_messages(messages) {
      this.servermessages = [];
      this.servermessages = messages;
    },
    clear_messages() {
      this.servermessages = [];
    },

    facet_keys(facet){
      // console.log(facet);
      this.facet_filters = facet;
      this.$refs.search_filter.rebuildFilter(facet);

      this.$refs.display_options.filter_changed(this.selected_filter, facet);
    },

    // filter_changed
    filter_changed(changed) {
      // console.log(changed);
      

      // const catCode = this.$route.params.categoryUri;
      // const filter_uri = this.mx_faceted_filter(changed);
      // const catDesc = this.$route.params.categoryDesc;
      // const catCode2 = this.$route.params.categoryUri2;

      // this.$router.push('/category-search/' + catCode + '/'+ catDesc + '/'+catCode2 + '?' + filter_uri);

      // this.selected_filter = changed;
      setTimeout(() => {
        this.$refs.keywords_list.solr_search(changed);  
      }, 1000);
    },

    removeFilter(f) {
      this.$refs.search_filter.removeFilter(f[0]);
    },

    clearAll() {
      this.$refs.search_filter.removeFilter('all');
    },

    // kit methods
    kit_catalog(isKit){
      // console.log('isKit = ' + isKit)
      if(isKit){
        this.isKit = true;
        this.page_title = 'Kit Catalog Search';
        // const selectedyear = this.$store.getters['vehicle/selectedyear'];
        // const selectedmake = this.$store.getters['vehicle/selectedmake'];
        // const selectedmodel = this.$store.getters['vehicle/selectedmodel'];

        // if(selectedyear == '' || selectedmake == '' || selectedmodel == '' ){
        //   this.openDialog = true;
        // }
      }else{
        this.isKit = false;
        this.page_title = 'Search Results';
      }
    },
    openSelectVehicle() {
      this.openDialog = true;
    },
    closeSelectVehicle() {
      this.openDialog = false;
    },
    selectedVehicleComplete() {
      this.openDialog = true;
    },
    filterPrice(filterVal) {
      // console.log('price = ' + filterVal);
      this.filter_price = filterVal
    },
    filterAvailability(filterVal) {
      // console.log('availability = ' + filterVal);
      this.filter_availability = filterVal
    },
  },
  computed: {
    ...mapGetters("message", [
        "sharedmessages",
        "sharedmessagestatus"
    ]),
    ...mapGetters("vehicle", [
        "selectedyear",
        "selectedmake",
        "selectedmodel",
        "selectedengine",
    ]),

    breadcrumbs(){
      const categories = this.$store.getters['product/categories'];
      const code1 = this.$route.params.categoryUri1;
      console.log('code1 = ' +  code1);
      const category1 = categories.filter((cat) => ((cat.DMCD01 === code1) && (cat.categorylevel === 1)));
      
      return category1[0].categoryname;
    },

    /**show pages */
    showing_page() {
      let pagesShowing = '';
      let pg = this.page - 1;
      let startpg = pg * this.perPage;
      let endpg = '';
      if(startpg == 0){
        startpg = 1;
      }else{
        startpg += 1;
      }

      if(this.total_results < (this.page * this.perPage)){
        endpg = this.total_results;
      }else{
        endpg = this.page * this.perPage;
      }

      pagesShowing += startpg + '-' + endpg;

      return pagesShowing;
    }
  },
  watch: {
    sharedmessagestatus(newVal) {
      if (newVal === 'complete') {
        // This indicates that messages were stored on the state
        let msgs = this.$store.getters['message/sharedmessages']

        if (msgs["SearchResults"] != undefined) {
          this.servermessages = msgs["SearchResults"];
        }

      }
      this.$store.dispatch("message/resetStatus");

    },

    categoryUri1(){
      // console.log('cat 1 - ' + newVal);
      this.$refs.keywords_list.solr_search();
    }
  },
  created() {
    this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
    });
    
    this.servermessages = [];

    this.selected_filter  = {};
  },

  
};
</script>